export interface ProjectDescriptionFormFields {
  projectId: string;
  description: string;
}

const toEdit = ({projectId, description}: ProjectDescriptionFormFields) => ({
  projectId,
  description,
});

const toMutation = ({projectId, description}: ProjectDescriptionFormFields) => ({
  projectId,
  description,
});

const ProjectDescriptionForm = {
  toEdit,
  toMutation,
};

export default ProjectDescriptionForm;
